module.exports = __webpack_public_path__ + "img/Cloud_1.e738200c.png";